import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminPartyBossSlotBooking from "./AdminPartyBossSlotBooking";
import AddonsWizardPage from "./AddonsWizardPage";
import AdminPartyBossSlotReviewPage from "./AdminPartyBossSlotReviewPage";

/**
 * Admin slot booking: form → add-ons → review (Pay Now / Save and Pay Later).
 */
export default function AdminPartyBossSlotBookingFlow() {
  return (
    <Routes>
      <Route index element={<AdminPartyBossSlotBooking />} />
      <Route path="addons" element={<AddonsWizardPage />} />
      <Route path="review" element={<AdminPartyBossSlotReviewPage />} />
      <Route path="*" element={<Navigate to="/admin/partyboss-slot-booking" replace />} />
    </Routes>
  );
}
